import { render, staticRenderFns } from "./RetailBillDeleted.vue?vue&type=template&id=36845d18&scoped=true"
import script from "./RetailBillDeleted.vue?vue&type=script&lang=js"
export * from "./RetailBillDeleted.vue?vue&type=script&lang=js"
import style0 from "./RetailBillDeleted.vue?vue&type=style&index=0&id=36845d18&prod&scoped=true&lang=css"
import style1 from "./RetailBillDeleted.vue?vue&type=style&index=1&id=36845d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36845d18",
  null
  
)

export default component.exports